import { render, staticRenderFns } from "./IndexConfiguracao.vue?vue&type=template&id=bdd6d6f8&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./IndexConfiguracao.vue?vue&type=style&index=0&id=bdd6d6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd6d6f8",
  null
  
)

export default component.exports